import { serviceHandler } from './service-executor';

const ORDER_URL = '/api/orders';

export const getAllOrders = (page, pagesize) => {
  const URL = `${ORDER_URL}/all?page=${page}&pageSize=${pagesize}`;
  return serviceHandler(URL, 'GET');
};

export const getOrdersByAppointment = (appointment, start, end, page, pagesize) => {
  const URL = `${ORDER_URL}/appointment/${appointment}?start=${start}&end=${end}&page=${page}&pageSize=${pagesize}`;
  return serviceHandler(URL, 'GET');
};

/* Get orders updated through driver app */
export const getOrdersUpdatedViaDriverApp = (start, end, from, pagesize) => {
  const URL = `${ORDER_URL}/loads?start=${start}&end=${end}&size=${pagesize}&from=${from}`;
  return serviceHandler(URL, 'GET');
};

export const getOrderById = orderId => {
  const URL = `${ORDER_URL}/id/${orderId}`;
  return serviceHandler(URL, 'GET');
};

export const save = order => {
  const URL = `${ORDER_URL}/save`;
  return serviceHandler(URL, 'POST', order);
};

export const update = order => {
  const URL = `${ORDER_URL}/update`;
  return serviceHandler(URL, 'POST', order);
};

export const deleteOrder = orderId => {
  const URL = `${ORDER_URL}/${orderId}`;
  return serviceHandler(URL, 'DELETE');
};

export const search = params => {
  const URL = `${ORDER_URL}/search`;
  return serviceHandler(URL, 'POST', params);
};

export const setNextStatusForOrder = (orderId, leg, timestamp, action, address) => {
  let URL = `${ORDER_URL}/${orderId}/legs/${leg.id}/status?action=${action}&appointment=${timestamp}`;  
  return address ? serviceHandler(URL, 'POST', address): serviceHandler(URL, 'POST');
};

// export const updateOrderRate = (orderId, rate) => {
//   const URL = `${ORDER_URL}/${orderId}/rate/update`;
//   return serviceHandler(URL, 'POST', rate);
// };

export const updateOrderLocation = (orderId, legId, locationId, orderLocation, locationType) => {
  if(locationType === 'Origin') {
    return serviceHandler(`${ORDER_URL}/${orderId}/legs/${legId}/terminals/${locationId}/update`, 'POST', orderLocation);
  } else {
    return serviceHandler(`${ORDER_URL}/${orderId}/legs/${legId}/consignees/${locationId}/update`, 'POST', orderLocation);
  }  
};

export const updateOrderEquipment = (orderId, id, orderEquipment, type) => {
  const URL = type === 'CONTAINER' ? `${ORDER_URL}/${orderId}/containers/${id}/update` : `${ORDER_URL}/${orderId}/chassis/${id}/update`;
  return serviceHandler(URL, 'POST', orderEquipment);
};

export const updateOrderSummary = (orderId, summary) => {
  const URL = `${ORDER_URL}/${orderId}/summary/update`;
  return serviceHandler(URL, 'POST', summary);
};

export const getOrderTimingStats = (orderId) => {
  const URL = `${ORDER_URL}/${orderId}/stats`;
  return serviceHandler(URL, 'GET');
};

export const getInvoiceByOrderId = (orderId) => {
  const URL = `${ORDER_URL}/${orderId}/invoice`;
  return serviceHandler(URL, 'GET');
};

export const getFilesByOrderId = (orderId, isOTR) => {
  return serviceHandler(`/api/document/list/${orderId}?isOTR=${isOTR}`, 'GET');
}

export const uploadFileAttachment = data => {
  const URL = `/api/document/upload`;
  return serviceHandler(URL, 'PUT', data);
};

export const updateFileAttachment = (data, uuid) => {
  const URL = `/api/document/update/${uuid}`;
  return serviceHandler(URL, 'PUT', data);
};

export const deleteFileAttachment = (orderId, uuid) => {
  const URL = `/api/document/delete/${orderId}/${uuid}`;
  return serviceHandler(URL, 'DELETE');
};

export const downloadFileAttachment = (uuid) => {
  const URL = `/api/document/download/${uuid}`;
  return serviceHandler(URL, 'GET');
};